<template>
  <div>
    <SampleSearchForm
      :listForm="searchList"
      @handlerSearch="onSearch"
      @handlerBtn="handlerBtn"
    />
    <div class="cml-button-group">
      <el-button
        size="mini"
        type="primary"
        :disabled="selectTab.length < 1"
        v-hasPermission="'sample-manage/sample-confirm-order'"
        @click="confirmBtn"
        >确认</el-button
      >
    </div>
    <p class="confirm-tip">
      收到样品申请单，请先确认，实物寄出后再填写快递单号。
    </p>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{ row.code }}</span>
      </template>
    </CommonTable>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
export default {
  components: { CommonTable, SampleSearchForm, SampleOperationLogDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { status: 'PASS' },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        {
          label: '产品信息',
          prop: 'id',
          slotColumn: true,
          slotName: 'idSlot',
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样时间', prop: 'askArrivalTime', width: 140 },
      ],
      tableDataTab: {},
      selectTab: [],
      listData: {}
    };
  },
  computed: {
    isDisabled() {
      return this.selectTab.length < 1;
    },
  },
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight(10);
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderConfirmInfoOrderList(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectTab = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // table选择框
    selectChange(arr) {
      this.selectTab = arr;
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 确认收货
    handlerBtn(val, data) {
      this[val](val, data);
    },
    confirmBtn() {
      this.addBtn('listBill', this.selectTab);
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>

<style lang="less" scoped>
.confirm-tip {
  position: absolute;
  right: 0;
  top: 1%;
  text-align: right;
  font-size: 12px;
  color: #AB0033;
  line-height: 14px;
  width: calc(100% - 850px);
  min-width: 160px;
}
</style>
